export class FrameAgreement {

    constructor(jsonObj : any = null) {
        
        if(jsonObj == null)
        {
            return;
        }
        
        this.name = jsonObj.name;        
        this.id = jsonObj.id;        
        this.enabled = jsonObj.enabled;
        this.quotaAccountName = jsonObj.quotaAccountName;
        this.quotaAccountId = jsonObj.quotaAccountId;
        this.managerPartIds = jsonObj.managerPartIds ? jsonObj.managerPartIds.map((id: number) => id) : [];
    }

    name : string;
    id: number;
    enabled: boolean;
    quotaAccountName: string;
    quotaAccountId: number;
    managerPartIds: number[];
}